<script>
import TwCard from '@/components/generic/tw-card.vue'
import FundraiserPublishButton from '@/components/fundraisers/fundraiser-publish-button.vue'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import TwContainerFullWidth from '../../generic/tw-container-full-width.vue'
import { useFundraiserPublicStore } from '@/stores/fundraiserPublic.js'
import TwButton from '@/components/generic/tw-button.vue'
import loggedInUserMixin from '@/mixins/loggedInUserMixin.js'
import TwGridDual from '@/components/generic/tw-grid-dual.vue'
import TwModal from '@/components/generic/modal/tw-modal.vue'
import FundraiserSocialsShare from '@/components/fundraisers/fundraiser-socials-share.vue'

export default {
  name: 'FundraiserTopHeader',
  components: { TwModal, FundraiserSocialsShare, TwGridDual, TwButton, TwContainerFullWidth, TwTransitionContainer, FundraiserPublishButton, TwCard },
  mixins:[loggedInUserMixin],
  props: {
    fundraiser: {
      type: Object,
      required: true
    }
  },
  computed: {
    canPublish() {
      if(this.loggedInUser) {
        return (this.loggedInUser.admin || this.fundraiser.owner_user_id === this.loggedInUser.id)
      }
      return false
    }
  },
  methods: { useFundraiserPublicStore }
}
</script>

<template>
  <div class="bg-white pt-3 pb-3">
    <div v-if="loggedInUser && (loggedInUser === fundraiser.owner_user_id || loggedInUser.admin)" class="-mt-3">
      <div v-if="canPublish && !fundraiser.published" class="rounded-lg p-4 bg-amber-100 mb-3 text-center w-full">
        <p class="text-sm">
          This campaign has not been published. It will not be visible to the public until you publish it. Only you can see it for now.
        </p>
      </div>
      <div v-else class="p-4 bg-green-100 mb-3 text-center w-full text-xs sm:text-sm">
        <span>This campaign is LIVE. Now is a great time to promote your cause by
          <router-link :to="{name: 'FundraiserCommunicationPage', params: { fundraiserId: fundraiser.id }, hash: '#emailcampaign' }" class="underline font-medium" target="_blank">creating an email campaign</router-link>
          or
          <tw-button variant="link" class="text-xs sm:text-sm font-medium underline" @click="$refs.shareModal.open()">sharing your page.</tw-button>
        </span>
      </div>
      <tw-modal ref="shareModal" ok-only ok-text="Close" variant="secondary" title="Share this fundraiser" @ok="$refs.shareModal.close()">
        <fundraiser-socials-share :fundraiser="fundraiser" />
      </tw-modal>
    </div>

    <tw-container-full-width class="max-w-[1360px]">
      <div class="flex flex-col sm:flex-row-reverse justify-between items-center gap-4">
        <div v-if="loggedInUser && canPublish" class="flex gap-2 w-full flex-col sm:flex-row-reverse sm:w-auto whitespace-nowrap">
          <div v-if="!fundraiser.published && validPaymentService && isMounted" class="flex-1">
            <fundraiser-publish-button size="sm" block class="capitalize" :fundraiser="fundraiser" />
          </div>
          <tw-button variant="light" icon="pencil" :to="{name: 'FundraiserDetailsPage', params: { fundraiserId: fundraiser.id} }" class="flex-1" size="sm">
            Edit Campaign
          </tw-button>
        </div>
        <tw-button v-if="!loggedInUser" :to="{name: 'Login'}" variant="link" class="absolute right-4 top-4 sm:relative sm:top-0 sm:right-0">
          Login
        </tw-button>
        <div v-if="loggedInUser && loggedInUser.id !== fundraiser.owner_user_id ">&nbsp;</div>

        <div v-if="fundraiser.logo_url">
          <router-link to="/">
            <img :src="fundraiser.logo_url" class="max-h-20 max-w-44 md:max-w-auto" :alt="fundraiser.title + ' logo'">
          </router-link>
        </div>
      </div>
    </tw-container-full-width>
  </div>
</template>

<style scoped>

</style>
